import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, EMPTY, Observable } from 'rxjs';
import { AccountMapping } from '../models/AccountMapping';
import { UrlService } from './url.service';
import { PagedData } from '../models/PagedData';
import { PageEvent } from '@angular/material/paginator';
import { Page } from '../models/Page';

@Injectable({
  providedIn: 'root',
})
export class AccountMappingService {
  private readonly url: string;

  constructor(private readonly http: HttpClient, private readonly urlService: UrlService) {
    this.url = this.urlService.generateUrl('accountMapping');
  }

  getAccountMappingData(page: PageEvent): Observable<PagedData<any>> {
    return this.http.post<PagedData<any>>(this.url + '/GetAccountMappingViewData', page).pipe(
      catchError((error: any) => this.handleError(error))
    );
  }

  updateItem(accountMapping: AccountMapping, isEdit: boolean, isOnlyLockChanged: boolean): Observable<void> {
    const url = `${this.url}/UpdateAccountMapping?isEdit=${isEdit}&isLockChanged=${isOnlyLockChanged}`;
    return this.http.post<void>(url, accountMapping).pipe(
      catchError((error: any) => this.handleError(error))
    );
  }

  exportAccountsToExcel(page: Page): Observable<Blob> {
    return this.http.post(this.url + '/ExportToExcel', page, {
      responseType: 'blob'
    }).pipe(catchError((error: any) => this.handleError(error)));
  }

  private handleError(error: any): Observable<never> {
    return EMPTY;
  }
}
